import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CaasContentService } from '../../services/caas-content.service';
import { NavigationService } from '../../services/navigation.service';
import { ImageService } from '../../services/image.service';
import { take } from 'rxjs/operators';
import {
  CaasError404,
  CaasLayout,
} from '../../../../hdi-components/src/shared/interfaces/caas/caas.interface';
import { MetaData } from 'hdi-components';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  errorContent?: CaasError404;
  seoRoute: string = '';
  errorCode?: '404' | '500';
  breadcrumbs: { title: string; url: string }[] = [];
  private pageIdentifier: string = '';
  getContentSubscription$: Subscription = new Subscription();
  seoRouteSubscription$: Subscription = new Subscription();
  breadcrumbsSubscription$: Subscription = new Subscription();

  constructor(
    private readonly caasContentService: CaasContentService,
    private readonly navigationService: NavigationService,
    private readonly route: ActivatedRoute,
    private readonly imageServices: ImageService
  ) {}

  ngOnInit(): void {
    // support both snapshot and observable data
    const snapshotData = this.route.snapshot?.data;
    if (snapshotData && Object.keys(snapshotData).length) {
      this.pageIdentifier = snapshotData['pageIdentifier'] || '';
      this.errorCode = snapshotData['errorCode'] || '404';
      this.initialize();
    } else if (this.route.data) {
      this.route.data.pipe(take(1)).subscribe((d) => {
        this.pageIdentifier = d['pageIdentifier'] || '';
        this.errorCode = d['errorCode'] || '404';
        this.initialize();
      });
    }
  }

  private initialize(): void {
    this.loadErrorContent();
    this.setSeoRoute();
    this.setBreadcrumbs();
  }

  private loadErrorContent(): void {
    if (!this.pageIdentifier) {
      console.error('Page identifier not found for error');
      return;
    }

    this.getContentSubscription$ = this.caasContentService
      .getContent(this.pageIdentifier)
      .subscribe({
        next: (content: { layouts: CaasLayout[]; metaData: MetaData }) => {
          const layouts = content.layouts;
          const errorLayout = layouts.find(
            (layout) =>
              layout.name.includes('error') ||
              layout.name.includes('404') ||
              layout.name.includes('500')
          );

          if (errorLayout?.children?.length) {
            this.errorContent = errorLayout.children[0] as CaasError404;
            this.imageServices.replaceErrorImage(this.errorContent);
          } else {
            console.warn('Error layout not found in CAAS content');
          }
        },
        error: (err) => {
          console.error('Error loading CAAS content', err);
        },
      });
  }

  private setSeoRoute(): void {
    this.seoRouteSubscription$ = this.navigationService
      .getCloudNavigation()
      .subscribe((navigation) => {
        if (this.pageIdentifier) {
          this.seoRoute =
            this.navigationService.getSeoRouteByIdentifier(
              this.pageIdentifier,
              navigation
            ) || 'error';
        }
      });
  }

  private setBreadcrumbs(): void {
    if (this.seoRoute) {
      this.navigationService.getCloudNavigation().subscribe((navigation) => {
        this.breadcrumbs = this.navigationService.generateBreadcrumbs(
          this.seoRoute,
          navigation
        );
      });
    } else {
      this.breadcrumbs = [{ title: 'Error', url: '/error' }];
    }
  }
  ngOnDestroy(): void {
    if (this.getContentSubscription$) {
      this.getContentSubscription$.unsubscribe();
    }
    if (this.seoRouteSubscription$) {
      this.seoRouteSubscription$.unsubscribe();
    }
    if (this.breadcrumbsSubscription$) {
      this.breadcrumbsSubscription$.unsubscribe();
    }
  }
}
